export default "__VITE_ASSET__Cv$SPIWE__"